export const TOPUP_CONFIG = {
  topupAmountMin: 10,
  topupAmountMax: 600
}
